import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-[#FBF7F4]" data-id="element-58">
      <div className="max-w-6xl mx-auto w-full" data-id="element-59">
        {/* Desktop: two columns */}
        <div className="hidden md:grid md:grid-cols-2 gap-12 items-center" data-id="element-60">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-61">
            <span className="inline-block py-1 px-3 border border-[#8B7355]/30 rounded-full text-xs font-medium tracking-widest text-[#8B7355] uppercase mb-6" data-id="element-62">
              Protocolo 21 Días
            </span>

            <h1 className="text-5xl lg:text-6xl font-serif font-medium leading-[1.1] text-[#2D2A26] mb-6" data-id="element-63">
              Tu piel no "empeoró". <br data-id="element-64" />
              <span className="italic text-[#C4A08A]" data-id="element-65">Cambió.</span> <br data-id="element-66" />Y tu
              rutina no se enteró.
            </h1>

            <p className="text-xl text-[#2D2A26]/80 font-light leading-relaxed mb-8 max-w-md" data-id="element-67">
              Deja de pelear con tu cara. Estabiliza rojeces y brotes reactivos
              en 21 días sin productos agresivos.
            </p>

            <div className="flex flex-row gap-4" data-id="element-68">
              <a href="#producto" className="bg-[#C4A08A] hover:bg-[#B08D79] text-white px-8 py-4 rounded-sm font-medium transition-all duration-300 flex items-center justify-center gap-2 shadow-lg shadow-[#C4A08A]/20" data-id="element-69">
                Obtener el Protocolo
                <ArrowRight className="w-4 h-4" data-id="element-70" />
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-71">
            <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl shadow-[#8B7355]/10" data-id="element-72">
              <img src="https://cdn.magicpatterns.com/uploads/noeiJWGfohP4uDCY4otu2T/mockup2-piel-en_perry.png" alt="PIEL EN PERI Protocolo en tablet y laptop" className="w-full h-auto object-cover" data-id="element-73" />
            </div>
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#C4A08A]/10 rounded-full blur-3xl -z-10" data-id="element-74"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#8B7355]/10 rounded-full blur-3xl -z-10" data-id="element-75"></div>
          </motion.div>
        </div>

        {/* Mobile: single column — headline → mockup → buttons */}
        <div className="md:hidden flex flex-col items-center text-center" data-id="element-76">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-77">
            <span className="inline-block py-1 px-3 border border-[#8B7355]/30 rounded-full text-xs font-medium tracking-widest text-[#8B7355] uppercase mb-4" data-id="element-78">
              Protocolo 21 Días
            </span>

            <h1 className="text-4xl font-serif font-medium leading-[1.1] text-[#2D2A26] mb-3" data-id="element-79">
              Tu piel no "empeoró". <br data-id="element-80" />
              <span className="italic text-[#C4A08A]" data-id="element-81">Cambió.</span> <br data-id="element-82" />Y tu
              rutina no se enteró.
            </h1>

            <p className="text-lg text-[#2D2A26]/80 font-light leading-relaxed mb-5" data-id="element-83">
              Deja de pelear con tu cara. Estabiliza rojeces y brotes reactivos
              en 21 días sin productos agresivos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative w-full mb-5" data-id="element-84">
            <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl shadow-[#8B7355]/10" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/noeiJWGfohP4uDCY4otu2T/mockup2-piel-en_perry.png" alt="PIEL EN PERI Protocolo en tablet y laptop" className="w-full h-auto object-cover" data-id="element-86" />
            </div>
            <div className="absolute -top-10 -right-10 w-48 h-48 bg-[#C4A08A]/10 rounded-full blur-3xl -z-10" data-id="element-87"></div>
            <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-[#8B7355]/10 rounded-full blur-3xl -z-10" data-id="element-88"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4,
          ease: 'easeOut'
        }} className="w-full" data-id="element-89">
            <a href="#producto" className="bg-[#C4A08A] hover:bg-[#B08D79] text-white px-8 py-4 rounded-sm font-medium transition-all duration-300 flex items-center justify-center gap-2 shadow-lg shadow-[#C4A08A]/20 w-full" data-id="element-90">
              Obtener el Protocolo
              <ArrowRight className="w-4 h-4" data-id="element-91" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}